import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import { FiLogIn } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { ButtonSpinner } from '../components/LoadingStates';

const logo = '/brand/zashani-logo-wide.png';

const Login = () => {
    const { user, login } = useAuth();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    if (user) {
        return <Navigate to="/" replace />;
    }

    const submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError('');
        try {
            await login(form);
        } catch (requestError) {
            setError(requestError.response?.data?.message || 'No fue posible iniciar sesion.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="login-page">
            <section className="login-shell">
                <div className="login-brand">
                    <img src={logo} alt="Zashani" />
                    <div className="login-brand-copy">
                        <p className="eyebrow">Acceso privado</p>
                        <h1>Zashani</h1>
                    </div>
                </div>
                <form className="login-panel" onSubmit={submit}>
                    <div>
                        <p className="eyebrow">Bienvenido</p>
                        <h2>Iniciar sesion</h2>
                    </div>
                    {error && <div className="alert">{error}</div>}
                    <label>
                        Correo
                        <input
                            type="email"
                            value={form.email}
                            onChange={(event) => setForm({ ...form, email: event.target.value })}
                            autoComplete="email"
                            required
                        />
                    </label>
                    <label>
                        Contrasena
                        <input
                            type="password"
                            value={form.password}
                            onChange={(event) => setForm({ ...form, password: event.target.value })}
                            autoComplete="current-password"
                            required
                        />
                    </label>
                    <button className="primary-button" type="submit" disabled={loading}>
                        {loading ? <ButtonSpinner /> : <FiLogIn />}
                        <span>{loading ? 'Entrando...' : 'Entrar'}</span>
                    </button>
                </form>
            </section>
        </main>
    );
};

export default Login;
